import script from "./AboutVue.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutVue.vue?vue&type=script&setup=true&lang=js"

import "./AboutVue.vue?vue&type=style&index=0&id=052d7208&lang=scss"

const __exports__ = script;

export default __exports__